import UnauthenticatedAppointmentModel from './unauthenticated-appointment';

export default class GroupAppointment extends UnauthenticatedAppointmentModel {}
